import { useCallback } from 'react';

import { useEditionAwareness } from './edition-awareness-context';
import { useGetExperimentValue } from './experiment-context';
import { isEligibleForUserLimitDirectBuy } from './is-eligible-for-user-limit-direct-buy';

export const USER_LIMIT_DIRECT_BUY_EXPERIMENT = 'twcg-2318_ea_user_limit_direct_buy_experiment';

const statsigParams = {
	experimentName: USER_LIMIT_DIRECT_BUY_EXPERIMENT,
	parameterName: 'cohort',
	defaultValue: 'not-enrolled' as const,
};

export function useUserLimitDirectBuyExperiment(): {
	expose: () => void;
} {
	const context = useEditionAwareness();
	const { getExperimentValue } = useGetExperimentValue();

	const expose = useCallback(() => {
		if (!isEligibleForUserLimitDirectBuy(context)) {
			return;
		}
		getExperimentValue({ statsigParams });
	}, [context, getExperimentValue]);

	return { expose };
}
